/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import VirtualTourHorizontalForm from '../VirtualTourHorizontalForm';

const VirtualTourLeftPart = (props) => {
  const { formPostUrl, cities, formAuthToken } = props;

  return (
    <div className="virtual-page">
      <div className="col-md-9">
        <h1 className="main-color bold">{I18n.t('virtual_office.page.title')}</h1>
        <h4 className="bold">{I18n.t('virtual_office.page.benefits')}</h4>
        <p dangerouslySetInnerHTML={{ __html: I18n.t('virtual_office.page.description') }} />

        <h4 className="bold virtual-page__list-title">{I18n.t('virtual_office.page.key_advantage')}</h4>

        <ul className="ticked-list">
          <li>{I18n.t('virtual_office.page.advantage_1')}</li>
          <li>{I18n.t('virtual_office.page.advantage_2')}</li>
          <li>{I18n.t('virtual_office.page.advantage_3')}</li>
          <li>{I18n.t('virtual_office.page.advantage_4')}</li>
          <li>{I18n.t('virtual_office.page.advantage_5')}</li>
        </ul>

        <VirtualTourHorizontalForm
          path={formPostUrl}
          cities={cities}
          formAuthToken={formAuthToken}

        />

      </div>
    </div>
  );
};

VirtualTourLeftPart.propTypes = {
  formPostUrl: PropTypes.string,
  cities: PropTypes.arrayOf(PropTypes.object),
  formAuthToken: PropTypes.string,
};

VirtualTourLeftPart.defaultProps = {
  formPostUrl: '',
  cities: [],
  formAuthToken: '',
};

export default VirtualTourLeftPart;
